import { reasonToThai } from './reason-codes';

export interface WhyNeedsReviewPanelProps {
  /** detectAnomaly reason codes — previewReasons (pre-accept) or anomalyReasons (post). */
  reasons: string[];
  /** 'preview' shows the pre-accept lead "ถ้ายอมรับจะส่งอนุมัติ…". */
  mode?: 'preview' | 'result';
  onJump: (fieldKey: string) => void;
}

export function WhyNeedsReviewPanel({
  reasons,
  mode = 'result',
  onJump,
}: WhyNeedsReviewPanelProps) {
  if (reasons.length === 0) return null;
  return (
    <div
      className="why-review card"
      style={{ padding: 12, borderLeft: '3px solid var(--warning)' }}
    >
      <div style={{ fontWeight: 600, marginBottom: 6 }}>
        {mode === 'preview'
          ? `ถ้ายอมรับจะส่งอนุมัติ 4 ตา เพราะ (${reasons.length})`
          : `เหตุผลที่ต้องอนุมัติ (${reasons.length})`}
      </div>
      <ul style={{ display: 'grid', gap: 6, margin: 0, paddingLeft: 18 }}>
        {reasons.map((code, i) => {
          const r = reasonToThai(code);
          return (
            <li key={`${code}-${i}`}>
              {r.text}
              {r.fieldKey && (
                <button
                  type="button"
                  className="btn sm ghost"
                  style={{ marginLeft: 6 }}
                  onClick={() => onJump(r.fieldKey!)}
                >
                  ไปที่ฟิลด์
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
